// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2UqjY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1O-rM"};